//
// Copyright (c) 2011-2020 by Curalate, Inc.
//
import moment from 'moment-timezone';

export function localDateToPst(date: Date): Date {
  return localDateToTimezone(date, 'America/Los_Angeles');
}

export function localDateToTimezone(date: Date, timezone: string): Date {
  // Returns the date timezone offset relative UTC
  const localTimezoneOffset = date.getTimezoneOffset();

  // Returns the date timezone offset relative UTC
  const destinationTimezone = moment.tz.zone(timezone);
  const destinationTimezoneOffset = destinationTimezone.parse(+date);

  // Compute the difference between the UTC timezone offsets
  const timezoneOffsetDelta = destinationTimezoneOffset - localTimezoneOffset;

  // Apply offset to move the date to the destination timezone, while keeping the same time
  // Ex 1: 2020-03-31T00:00:00-04:00 => PDT => 2020-03-31T:00:00:00-07:00
  // Ex 2: 2020-03-31T00:00:00-07:00 => PDT => 2020-03-31T:00:00:00-07:00
  return moment(date).add(timezoneOffsetDelta, 'minutes').toDate();
}
